// import TermsofUse from "components/TermsofUse"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"

const AppFooter = ({ disclosure, diffLayout }) => (
  <Grid.Row
    columns={2}
    className={`AppFooter no-print ${diffLayout ? "diffFooter" : ""}`}
  >
    <Grid.Column>
      Copyright {new Date().getFullYear()} SAVVI Financial LLC
    </Grid.Column>
    <Grid.Column textAlign="right">{disclosure}</Grid.Column>
  </Grid.Row>
)

export default AppFooter
